<template>
    <div style="margin: 2em 2em 0.5em 2em;">
        <div class="box">
            <BInputText
                    label-text="角色名称"
                    :required="true"
                    v-model="roleName"
                    :maxLength="20"
                    :disabled="roleName === '班主任' || roleName === '学生' ? true:false"
                    placeholder="请输入角色名称"
            />
        </div>
        <div class="box" style="margin: 12px 0">
            <label
                    style="
          margin: 0px 10px 0 20px;
          width: 60px;
          font-size: 14px;
          color: #333333;
          text-align: right;
        "
            >操作权限</label
            >
            <BBtnCheckbox
                    id="menu"
                    label-text="全部"
                    :value="checkallflg"
                    :booleanValue="checkallflg"
                    @changed="checkall"
            />
        </div>
        <div class="box">
            <label
                    style="
          margin: 0px 10px 0 20px;
          width: 60px;
          font-size: 14px;
          color: #333333;
          text-align: right;
        "
            ></label
            >
            <div style="display: flex; flex-wrap: wrap; max-width: 350px">
                <div v-for="page in items" :key="page.value">
                    <BBtnCheckbox
                            :id="page.id"
                            :label-text="page.itemlabel"
                            :value="page.booleanValue"
                            :booleanValue="page.booleanValue"
                            @changed="checkChanged(page.value)"
                            style="margin: 15px 0"
                    />
                </div>
            </div>
        </div>
        <div class="box">
            <BBtnPrimary
                    v-if="editflg == false"
                    :clicked="handleAdd"
                    btn-txt="添加"
            />
            <BBtnPrimary v-else :clicked="handleEdit" btn-txt="修改"/>
            <BBtnPrimary :clicked="upConfirmSuccess" btn-txt="返回"/>
        </div>
    </div>
</template>
<script>
    import {roleAddInit, roleAdd, roleEdit} from "@/api/roleManagement";
    import BInputText from "../../components2/BInputText";
    import BBtnCheckbox from "../../components2/BBtnCheckbox";
    import BBtnPrimary from "../../components2/BBtnPrimary";
    import Vue from "vue";

    export default {
        components: {
            BInputText,
            BBtnCheckbox,
            BBtnPrimary,
        },
        data: () => ({
            roleName: "",
            items: [],
            checkallflg: false,
            checked: [],
            roleId: 0,
        }),
        props: {
            editflg: Boolean,
            id: Number,
            name: String,
        },
        mounted() {
            if (this.editflg == true) {
                this.roleId = this.id;
                this.roleName = this.name;
            }
            // 页面初期化
            this.init();
        },
        methods: {
            // 初始化
            async init() {
                var param = {
                    id: this.roleId,
                    roleName: this.name,
                };
                const data = await roleAddInit(param);
                let itemsDataList = [];
                let ltemLen = data.pageList.length;
                for (let i = 0; i < ltemLen; i++) {
                    var itemsData = {
                        id: "class" + data.pageList[i].id,
                        value: data.pageList[i].id,
                        itemlabel: data.pageList[i].pageName,
                        booleanValue: false,
                    };
                    if (data.pageIdList != null && data.pageIdList.length > 0) {
                        let pageIdLen = data.pageIdList.length;
                        for (let j = 0; j < pageIdLen; j++) {
                            if (data.pageList[i].id === data.pageIdList[j]) {
                                itemsData.booleanValue = true;
                                this.checked.push(data.pageList[i].id);
                                break;
                            }
                        }
                    } else {
                        itemsData.booleanValue = false;
                    }
                    itemsDataList.push(itemsData);
                }
                this.items = itemsDataList;

                // checkBox全部勾选
                if (this.checked.length === this.items.length) {
                    this.checkallflg = true;
                } else {
                    this.checkallflg = false;
                }
            },
            handlePermission() {
                let routerPath = "/business/permission-management";
                this.$router.push({path: routerPath});
            },
            handleRole() {
                let routerPath = "/business/role-management";
                this.$router.push({path: routerPath});
            },
            handleAdd() {
                if (!this.roleName) {
                    Vue.prototype.$valertbar.show("请输入角色名称");
                    return;
                }
                this.add();
            },
            async add() {
                var param = {
                    roleName: this.comUtils.trim(this.roleName),
                    pageId: this.checked,
                };
                const data = await roleAdd(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.upConfirmSuccess();
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
            handleEdit() {
                if (!this.roleName) {
                    Vue.prototype.$vsnackbar.show("请输入角色名称");
                    return;
                }
                this.edit();
            },
            async edit() {
                var param = {
                    roleId: this.roleId,
                    roleName: this.comUtils.trim(this.roleName),
                    pageId: this.checked,
                };
                const data = await roleEdit(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.upConfirmSuccess();
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
            upConfirmSuccess() {
                var obj = {
                    flag: 2,
                };
                this.$emit("openFlag", obj);
            },
            // 全部
            checkall(e) {
                let len = this.items.length;
                if (e) {
                    this.checked = [];
                    for (let i = 0; i < len; i++) {
                        this.items[i].booleanValue = true;
                        this.checked.push(this.items[i].value);
                    }
                } else {
                    this.checked = [];
                    for (let i = 0; i < len; i++) {
                        this.items[i].booleanValue = false;
                    }
                }
            },
            // 权限勾选
            checkChanged(value) {
                let index = -1;
                if (this.checked != null && this.checked.length > 0) {
                    let len = this.checked.length;
                    for (let i = 0; i < len; i++) {
                        if (this.checked[i] === value) {
                            index = i;
                        }
                    }
                }

                if (index > -1) {
                    this.checked.splice(index, 1);
                } else {
                    this.checked.push(value);
                }

                // checkBox全部勾选
                if (this.checked.length === this.items.length) {
                    this.checkallflg = true;
                } else {
                    this.checkallflg = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
